module.exports = __webpack_public_path__ + "img/pay_size_sel6.8b16e103.png";